// Mock data for SolinoPro showcase website

export const companyInfo = {
  name: "SolinoPro",
  tagline: "Pose de sols, murs & escaliers",
  description: "Artisan BTP spécialisé dans la pose de revêtements de sol, l'habillage d'escaliers et les finitions murales. Un savoir-faire professionnel au service de vos projets de rénovation et construction.",
  phone: "06 50 08 82 82",
  instagram: "@solinopro",
  logo: "https://customer-assets.emergentagent.com/job_125789ef-3ae3-4ea2-b73d-645285e7312a/artifacts/9zemqpgv_IMG_9139.png"
};

export const services = [
  {
    id: 1,
    title: "Pose de sols",
    description: "Installation professionnelle de tous types de revêtements : carrelage, parquet, PVC, lino. Travail soigné et durable.",
    icon: "Layers",
    image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/ehh31kr6_IMG_9178.jpeg"
  },
  {
    id: 2,
    title: "Habillage d'escaliers",
    description: "Rénovation et habillage d'escaliers : marches intégrales, nez de marche, béton ciré. Expertise et finitions impeccables.",
    icon: "Stairs",
    image: "https://images.unsplash.com/photo-1768321911201-8e09d59f18c8"
  },
  {
    id: 3,
    title: "Finitions murales",
    description: "Pose de bandes, enduits, ratissage, peinture, BA13. Des murs parfaitement préparés pour vos projets.",
    icon: "PaintBucket",
    image: "https://images.unsplash.com/photo-1703868669362-562283170216"
  }
];

export const catalogueData = {
  poseSol: {
    title: "Pose du sol",
    items: [
      {
        name: "Carrelage sol et murs",
        price: "30€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/aytz6rsh_IMG_9150.jpeg"
      },
      {
        name: "Carrelage mosaïque",
        price: "60€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/sjkk6ac7_IMG_9151.jpeg"
      },
      {
        name: "Parquet flottant",
        price: "27€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/ayitsfzs_IMG_9152.jpeg"
      },
      {
        name: "PVC",
        price: "25€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/gblxtxij_IMG_9153.jpeg"
      },
      {
        name: "Lino classique",
        price: "10€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/5pmznnu9_IMG_9154.jpeg"
      },
      {
        name: "Lino naturel",
        price: "27€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/sum5g4cq_IMG_9155.jpeg"
      }
    ]
  },
  preparation: {
    title: "Préparation du sol et finition",
    items: [
      {
        name: "Peinture époxy",
        price: "14€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/y6qtfd8k_IMG_9156.jpeg"
      },
      {
        name: "Ragréage simple",
        price: "17€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/pt1ogspg_IMG_9157.jpeg"
      },
      {
        name: "Ragréage fibré",
        price: "20€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/pt1ogspg_IMG_9157.jpeg"
      },
      {
        name: "Joint pour le carrelage",
        price: "3€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/x3963ezs_IMG_9158.jpeg"
      },
      {
        name: "Soudure à chaud",
        price: "20€ mètre linéaire",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/zy2zav38_IMG_9159.jpeg"
      },
      {
        name: "Soudure à froid",
        price: "10€ mètre linéaire",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/glt5a5c3_IMG_9160.jpeg"
      }
    ]
  },
  escaliers: {
    title: "Habillage d'escaliers",
    items: [
      {
        name: "Marché intégral",
        price: "15€ par marche",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/or94qtvu_IMG_9161.jpeg"
      },
      {
        name: "Nez de marche en PVC",
        price: "25€ par marche",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/bldff272_IMG_9162.jpeg"
      },
      {
        name: "Nez de marche en aluminium",
        price: "50€ par marche",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/baul98vl_IMG_9163.jpeg"
      },
      {
        name: "Marche béton ciré",
        price: "200€ par marche",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/jxi2qcie_IMG_9164.jpeg"
      },
      {
        name: "Marche escalier sol stratifié",
        price: "60€ par marche",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/crv9021u_IMG_9165.jpeg"
      },
      {
        name: "Peinture d'escalier",
        price: "20€ par marche",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/9fb86lo3_IMG_9166.jpeg"
      },
      {
        name: "Vernissage d'escalier",
        price: "15€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/3jxs3fuu_IMG_9167.jpeg"
      }
    ]
  },
  mural: {
    title: "Pose et réparation murale",
    items: [
      {
        name: "Pause de bande plate",
        price: "8€ le mètre linéaire",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/hjw2dk3r_IMG_9168.jpeg"
      },
      {
        name: "Pause de bande angulaire",
        price: "12€ le mètre linéaire",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/lyq0w484_IMG_9169.jpeg"
      },
      {
        name: "Enduit général",
        price: "entre 25€ - 50€",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/k16enxii_IMG_9170.jpeg"
      },
      {
        name: "Enduit superficielle",
        price: "15€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/n9h6n6x2_IMG_9171.jpeg"
      },
      {
        name: "Ratissage",
        price: "25€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/n9h6n6x2_IMG_9171.jpeg"
      },
      {
        name: "Peinture simple",
        price: "18€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/bdih54g6_IMG_9172.jpeg"
      },
      {
        name: "Toile de verre",
        price: "15€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/0mkpupw3_IMG_9173.jpeg"
      },
      {
        name: "BA13",
        price: "20€ le M²",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/ci5lge2a_IMG_9174.jpeg"
      }
    ]
  },
  portes: {
    title: "Ajustement de portes",
    items: [
      {
        name: "Barre de seuil de porte",
        price: "10€ le mètre linéaire",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/7z1tevxz_IMG_9175.jpeg"
      },
      {
        name: "Rabotage de porte intérieure",
        price: "25€",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/s2uqpblc_IMG_9176.jpeg"
      },
      {
        name: "Rabotage de porte palière",
        price: "120€ l'unité",
        image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/s2uqpblc_IMG_9176.jpeg"
      }
    ]
  }
};

export const realisations = [
  {
    id: 1,
    title: "Carrelage gris salle de bain",
    category: "Salle de bain",
    image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/qakhni1b_IMG_9142.jpeg"
  },
  {
    id: 2,
    title: "Sol marbre blanc et douche",
    category: "Salle de bain",
    image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/hqvv0zrd_IMG_9143.jpeg"
  },
  {
    id: 3,
    title: "Crédence marbre noir cuisine",
    category: "Cuisine",
    image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/zp75qqdk_IMG_9145.jpeg"
  },
  {
    id: 4,
    title: "Construction abri bois",
    category: "Menuiserie",
    image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/7bd7nzmt_IMG_9146.jpeg"
  },
  {
    id: 5,
    title: "Installation parquet bois",
    category: "Sol",
    image: "https://customer-assets.emergentagent.com/job_solinopro-showcase/artifacts/misi6hyg_IMG_9179.jpeg"
  }
];
